import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { optimizeLabelStack } from '../common/utils';
export function optimizeSpans(spans, interactionStart, reactUFOVersion) {
  var updatedSpans = spans.reduce(function (result, span) {
    var labelStack = span.labelStack,
      type = span.type,
      name = span.name,
      start = span.start,
      end = span.end;
    if (labelStack && start >= interactionStart) {
      result.push({
        labelStack: optimizeLabelStack([].concat(_toConsumableArray(labelStack), [{
          name: name
        }]), reactUFOVersion),
        startTime: Math.round(start),
        endTime: Math.round(end),
        type: type
      });
    }
    return result;
  }, []);
  return updatedSpans;
}